import { useExtendWithSubnetworks, useNetworksStateContext } from "@l2r-front/l2r-networks"

import { API_MODULE_MIRANDA } from "../../../../../common/constants/appRoad"

import { mirandaQueryKeys } from "./queryKeys"
import { useMirandaQuery } from "./useMirandaQuery"

export function useMirandaGradingLayer(year, queryParameters, config = {}) {

    const { selectedNetwork } = useNetworksStateContext()

    const parameters = useExtendWithSubnetworks({
        ...queryParameters,
        datetime__year: year,
        as_geojson: true,
        project: selectedNetwork?.slug,
    }, API_MODULE_MIRANDA)
    const { enabled = true } = config
    const queryKey = mirandaQueryKeys["layer"]({ year, ...parameters })
    const url = "network_grades/"

    return useMirandaQuery(
        url,
        queryKey,
        parameters,
        {
            ...config,
            enabled: !!year && enabled,
        },
    )
}
